import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-nica-popup-text',
  templateUrl: './nica-popup-text.component.html',
  styleUrls: ['./nica-popup-text.component.css']
})
export class NicaPopupTextComponent implements OnInit {
  @Input() contenuto: string
  private safeContenuto: SafeHtml
  constructor(private sanitizer: DomSanitizer) { }
  get html(): SafeHtml {
    return this.safeContenuto;
  }
  ngOnInit(): void {
    if (this.contenuto) {
      this.safeContenuto = this.sanitizer.sanitize(SecurityContext.HTML, this.contenuto);
    }
  }
}